import styled, { css } from 'styled-components'

import { FooterProps } from '../../config/types'

const fontStyling = css`
  font-size: 2.3vw;
  color: #ffffff;
`

const Container = styled.div<{ right?: boolean }>`
  position: absolute;
  display: flex;
  flex-direction: ${({ right }) => (right ? 'column' : 'row')};

  align-items: ${({ right }) => (right ? 'flex-end' : 'flex-start')};

  width: fit-content;
  height: auto;

  bottom: 0;

  ${({ right }) => (right ? 'right: 0' : 'left: 0')};

  z-index: 2;

  padding: 0.3em;

  .r-ic {
    width: fit-content;
  }

  sup {
    line-height: 0em;
  }

  ${fontStyling};
`

const Link = styled.a`
  ${fontStyling};
`

// const Text = styled.span`
//   text-decoration: underline;
//   ${fontStyling}
// `

// const Divider = styled.div`
//   ${fontStyling};
//   margin: 0 0.3em;
// `

/**
 * Bottom links
 */
const Footer = ({ launch }: FooterProps) => {
  return (
    <>
      {launch && (
        <Container>
          <Link
            href="https://www.crayola.com/privacy.aspx"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </Link>
          {/* <Divider>|</Divider>
          <Text onClick={launch}>Launch w/o Analytics Cookies</Text> */}
        </Container>
      )}

      <Container right>
        {/* {launch && <div className="r-ic">®</div>} */}
        <span>
          © 2022 Crayola
          <sup>&reg;</sup>
        </span>
      </Container>
    </>
  )
}

export default Footer
